import { OrganizationDownloadUsage } from "../../types";
import { PLAN_DOWNLOAD_CONFIGS, WindowType } from "../../lib/consts";

// // // //

export type ViewState =
    | "loading_usage"
    | "limit_exceeded"
    | "awaiting_confirmation"
    | "preparing_download"
    | "download_ready";

export interface UsageBreakdown {
    count: number;
    limit: number;
    period: WindowType;
}

export function getViewState(props: {
    usage: OrganizationDownloadUsage | null;
    isLoadingDownloadUrl: boolean;
    downloadUrl: string | null;
}): ViewState {
    const { usage, isLoadingDownloadUrl, downloadUrl } = props;

    if (isLoadingDownloadUrl) {
        return "preparing_download";
    }
    if (!usage) return "loading_usage";
    if (downloadUrl) return "download_ready";
    if (usage?.limit_exceeded) return "limit_exceeded";
    return "awaiting_confirmation";
}

export function getUsageBreakdown(
    usage: OrganizationDownloadUsage,
): UsageBreakdown | null {
    const config = PLAN_DOWNLOAD_CONFIGS[usage.plan_type];

    // Unlimited plans have no metered breakdown to show
    if (config.downloadLimit === Infinity) return null;

    switch (config.window) {
        case "daily":
            return {
                count: usage.rolling_1d_count,
                limit: usage.rolling_1d_limit,
                period: "daily",
            };
        case "weekly":
            return {
                count: usage.rolling_7d_count,
                limit: usage.rolling_7d_limit,
                period: "weekly",
            };
        case "monthly":
            return {
                count: usage.rolling_30d_count,
                limit: usage.rolling_30d_limit,
                period: "monthly",
            };
    }
}
